module.exports = __webpack_public_path__ + "static/media/SupportIcon.6bd5aa74.svg";